import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  ldIntercomMessage: 'I want to request a credit line.',
  ldIntercomButton: 'Request your credit line',
  ldBtnTitle: 'Collect Payins in Local Currency',
  ldBtnBadge: 'New',
  ldTblSelector: 'Credit line',
  ldTblName: 'Supplier name',
  ldTblStatus: 'Credit status',
  ldTblAdvance: 'EFEX advance',
  ldTblFunds: 'Own funds advance',
  ldTblRequestDate: 'Request date',
  ldTblAmount: 'Amount',
  ldTblDesAmount: 'Destiny amount',
  ldTblSettlementDate: 'Settlement date',
  ldTblBill: 'Invoice/PO',
  ldZsHeader: 'The benefits of getting a credit line with EFEX',
  ldZsDescription:
    'Offer your suppliers an advanced payment to provide them with liquidity, build loyalty, and as a result grow your business.',
  ldZsAction: 'Request your credit line',
  ldZsBenefit1:
    'We finance your suppliers POs/purchase orders up to 66% and their invoices up to 80%.',
  ldZsBenefit2: 'Monthly rates between 1.15% and 2%.',
  ldZsBenefit3: 'Financing in USD or MXN.',
  ldZsBenefit4:
    'The supplier can accept or reject this advance. If accepted, the discount would be made to the supplier at the time of settlement.',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const LENDING_LABELS: Record<Language, Record<LabelsLanguage, string>> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    ldIntercomMessage: 'Quiero solicitar una línea de crédito.',
    ldIntercomButton: 'Solicita tu línea de crédito',
    ldBtnTitle: 'Cobrar a tus clientes en moneda local',
    ldBtnBadge: 'Nuevo',
    ldTblSelector: 'Crédito para adelanto',
    ldTblName: 'Nombre del proveedor',
    ldTblStatus: 'Estado del crédito',
    ldTblAdvance: 'Adelanto EFEX',
    ldTblFunds: 'Adelanto fondos propios',
    ldTblRequestDate: 'Fecha de solicitud',
    ldTblAmount: 'Monto',
    ldTblDesAmount: 'Monto destino',
    ldTblSettlementDate: 'Fecha de liquidación',
    ldTblBill: 'Factura/PO',
    ldZsHeader: 'Los increíbles beneficios del crédito para adelanto',
    ldZsDescription:
      'Ofréceles a tus proveedores un pago adelantado para proveerles liquidez, liquidizarlos y, de esa forma, poder hacer crecer tu negocio.',
    ldZsAction: 'Solicita tu línea de crédito',
    ldZsBenefit1:
      'Financiamos los POs/órdenes de compra de tus proveedores hasta un 66% y sus facturas hasta un 80%.',
    ldZsBenefit2: 'Tasas mensuales entre el 1.15% y el 2%.',
    ldZsBenefit3: 'Financiamiento en USD o MXN.',
    ldZsBenefit4:
      'El proveedor puede aceptar o rechazar este adelanto. Si lo acepta, el descuento se le haría al proveedor en el momento de la liquidación.',
  },
};

export default LENDING_LABELS;
